const prefix = 'INDICATOR_ANALYTICS_V2';

export const POPULATE_CONTEXT = `${prefix}/POPULATE_CONTEXT`;
export const POPULATE_PLAN_SCOPE_DETAILS = `${prefix}/POPULATE_PLAN_SCOPE_DETAILS`;
export const POPULATE_INDICATORS = `${prefix}/POPULATE_INDICATORS`;
export const POPULATE_INDICATOR_COUNT = `${prefix}/POPULATE_INDICATOR_COUNT`;
export const POPULATE_INDICATOR_BREAKOUT_DETAILS = `${prefix}/POPULATE_INDICATOR_BREAKOUT_DETAILS`;
export const SET_PLAN_SCOPE = `${prefix}/SET_PLAN_SCOPE`;
export const SET_INDICATOR = `${prefix}/SET_INDICATOR`;
export const SET_INDICATOR_TYPE = `${prefix}/SET_INDICATOR_TYPE`;
export const OPEN_DETAILS_DRAWER = `${prefix}/OPEN_DETAILS_DRAWER`;
export const CLOSE_DETAILS_DRAWER = `${prefix}/CLOSE_DETAILS_DRAWER`;
export const SET_SCHOOL_YEAR = `${prefix}/SET_SCHOOL_YEAR`;
export const SET_LOADING_INDICATORS = `${prefix}/SET_LOADING_INDICATORS`;
export const SET_INCOMING_SEARCH_TERM = `${prefix}/SET_INCOMING_SEARCH_TERM`;
export const APPEND_INDICATORS = `${prefix}/APPEND_INDICATORS`;
export const POPULATE_INDICATORS_ANALYTICS_SEARCH_STATE = `${prefix}/POPULATE_INDICATORS_ANALYTICS_SEARCH_STATE`;
export const CLEAR_INDICATOR_BREAKOUT_DETAILS = `${prefix}/CLEAR_INDICATOR_BREAKOUT_DETAILS`;
export const CLEAR_INDICATORS_ANALYTICS_SEARCH_STATE = `${prefix}/CLEAR_INDICATORS_ANALYTICS_SEARCH_STATE`;
export const UPDATE_GRID_STUDENT_COUNTS = `${prefix}/UPDATE_GRID_STUDENT_COUNTS`;
export const SET_ACTIVE_ELEMENT = `${prefix}/SET_ACTIVE_ELEMENT`;
export const GLOBAL_ACTIVE_PLAN_SCOPE = 'global';
export const DISTRICT_ACTIVE_PLAN_SCOPE = 'district';
